var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%] height-three-rows"},[_c('page-header',{attrs:{"header-title":_vm.$t('INBOX_MGMT.ADD.AUTH.TITLE'),"header-content":_vm.useInstallationName(
        _vm.$t('INBOX_MGMT.ADD.AUTH.DESC'),
        _vm.globalConfig.installationName
      )}}),_vm._v(" "),_c('div',{staticClass:"mt-6 mx-0 flex flex-wrap"},_vm._l((_vm.channelList),function(channel){return _c('channel-item',{key:channel.key,attrs:{"channel":channel,"enabled-features":_vm.enabledFeatures},on:{"channel-item-click":_vm.initChannelAuth}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }